// @flow
const getDaySuffix = (dayNumber: number): string => {
  if (dayNumber >= 11 && dayNumber <= 13) return 'th';

  switch (dayNumber % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const formatDaySuffix = (statementDayOfMonth: string | number): string => {
  let dayNumber;
  if (typeof statementDayOfMonth === 'string') {
    dayNumber = Number(statementDayOfMonth);
  } else {
    dayNumber = statementDayOfMonth;
  }
  return `${dayNumber}${getDaySuffix(dayNumber)}`;
};

export default formatDaySuffix;
